import React from 'react';
// import { history } from '../../../../Store/middleware';
import styles from './_navigation-menu.module.scss';
import PersonIcon from '@mui/icons-material/Person';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import SideDrawer from '../../Layout/SideDrawer/SideDrawer';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
// import { Button } from '@mui/material';
import { Button } from '@progress/kendo-react-buttons';

import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { PermissionSet, User } from '../../../../Models/User';
import { userHasPermission } from '../../../../Helpers/Utilities';
import { permissions } from '../../../../Helpers/Constants';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../Store/rootReducer';
import { hasValue } from '@amsanalytics/react-shared-library';
import { useNavigate } from 'react-router-dom';
export default function NavigationMenu(props: { user: User | null, closeDrawer: () => void }) {
  const currentUser = useSelector((state: AppState) => state.shared.currentUser);
  const navigate = useNavigate();
  // the selected client id
  const selectedClientId = useSelector((state: AppState) => state.performanceReport.selectedClientId) ?? currentUser?.clientId;
  return <SideDrawer
    style={{backgroundColor: '#333333'}}
    
    content={
      <>
        <Button
          className={styles.navigationMenuButton}
          color="primary"
          style={{ borderTop: 'solid .5px white', }}
          startIcon={<DashboardIcon  style={{marginRight: '10px'}}/>}
          // variant="contained"
          onClick={() => {
            navigate('/');
            props.closeDrawer();
          }}
        >DASHBOARD
        </Button>
        <Button
          className={styles.navigationMenuButton}
          color="primary"
          // style={{ borderRadius: 0, display: 'flex', justifyContent: 'flex-start', backgroundColor: '#333333' }}
          startIcon={<PersonIcon  style={{marginRight: '10px'}}/>}
          // variant="contained"
          onClick={() => {
            navigate('/performanceReporting');
            props.closeDrawer();
          }}
        >INPUT DATA</Button>
        {
          props.user && (props.user.isSuperUser ||  userHasPermission(props.user, permissions.users, PermissionSet.U)) && (
            <Button
              className={styles.navigationMenuButton}
              color="primary"
              // style={{ borderRadius: 0, display: 'flex', justifyContent: 'flex-start', backgroundColor: '#333333' }}
              startIcon={<BadgeOutlinedIcon style={{marginRight: '10px'}} />}
              // variant="contained"
              onClick={() => {
                navigate('/dealerManagement');
                props.closeDrawer();
              }}
            >DEALER MANAGEMENT</Button>
          )
        }
        {
          props.user && (
            <Button
              className={styles.navigationMenuButton}
              color="primary"
              // style={{ borderRadius: 0, display: 'flex', justifyContent: 'flex-start', backgroundColor: '#333333' }}
              startIcon={<AccountCircleOutlinedIcon  style={{marginRight: '10px'}}/>}
              // variant="contained"
              disabled={!hasValue(selectedClientId)}
              onClick={() => {
                navigate('/userManagement');
                props.closeDrawer();
              }}
            >
              {hasValue(selectedClientId) ? 'USER MANAGEMENT' : 'USER MANAGEMENT (admins select a member)'}
            </Button>
          )
        }
        {
          props.user && (props.user?.isSuperUser || userHasPermission(props.user, permissions.clients, PermissionSet.U)) && (
            <Button
              className={styles.navigationMenuButton}
              color="primary"
              // style={{ borderRadius: 0, display: 'flex', justifyContent: 'flex-start', backgroundColor: '#333333', borderBottom: 'solid .5px #d95137' }}
              style={{  borderBottom: 'solid .5px #d95137' }}
              startIcon={<Groups2OutlinedIcon  style={{marginRight: '10px'}}/>}
              // variant="contained"
              // disabled={!hasValue(selectedClientId)}
              onClick={() => {
                navigate('/dealerGroupManagement');
                props.closeDrawer();
              }}
            >
              DEALER GROUP MANAGEMENT
            </Button>
          )
        }        
      </>
    } 
    title={"Menu"} 
    hideCloseButton={false}
    closeDrawer={props.closeDrawer}
  />
}
